import client from '../axios';

import axios from 'axios';
import { GET_COMMON_CHECKPHONE, GET_COMMON_BRANCHLIST, GET_COMMON_SCHOOLLIST, GET_COMMON_TEAMLIST, GET_LIST, POST_COMMON_SENDMESSAGE, POST_LOGIN, PUT_LIST_SETTING, GET_COMMON_AREALIST, GET_EXCEL_DOWNLOAD, GET_EXCEL_FORM_DOWNLOAD, GET_EXCEL_REPORT_DOWNLOAD, POST_FILE_UPLOAD, GET_COMMON_INFO_SCHOOL, GET_COMMON_INFO_MEMBER, GET_COMMON_INFO_COURCE, GET_COMMON_INFO_AGE, GET_COMMON_ID, GET_COMMON_FILE_DOWNLOAD, GET_COMMON_SCHOOL_CANCEL_LIST, GET_COMMON_BOOK_CATEGORY, GET_COMMON_PRODUCT_CATEGORY, POST_COMMON_BOOK_1ST_CATEGORY, PUT_COMMON_BOOK_1ST_CATEGORY, POST_COMMON_BOOK_2ST_CATEGORY,PUT_COMMON_BOOK_2ND_CATEGORY, DELETE_COMMON_BOOK_1ST_CATEGORY, DELETE_COMMON_BOOK_2ST_CATEGORY, POST_COMMON_COL_UPDATE, GET_COMMON_CHECKEMAIL, GET_COMMON_BOOK_CLASS, POST_EXCEL_UPLOAD, GET_COMMON_BOOK_FIRST,POST_EXCEL_UPLOAD_BRANCH_REGION, GET_SCHOOL_STATISTICS_ALL, POST_ORDER_SENDMESSAGE, GET_COMMON_CHECK_BRANCH_NAME, GET_COMMON_CHECK_SCHOOL_NAME, POST_EXCEL_UPLOAD_POINT_CART } from './endpoint';

export const loginAPI = (data) => {
  const config = {};
  return client.post(POST_LOGIN, data, config);
};

// 전화번호 중복체크
export const getCellphoneCheck = (data) => {
  return client.get(GET_COMMON_CHECKPHONE, { params: { cell_phone: data } });
};
// 리스트ß
export const getListAPI = (params) => {
  if (params) {
    return client.get(GET_LIST, { params });
  } else {
    return client.get(GET_LIST);
  }
};

//표설정 변경
export const putListSettingAPI = (data) => {
  return client.put(PUT_LIST_SETTING, data);
};

// 아이디 중복체크
export const getCheckIdAPI = (params) => {
  return client.get(GET_COMMON_ID, { params });
};

// 이메일 중복체크
export const getCheckEmailAPI = (params) => {
  return client.get(GET_COMMON_CHECKEMAIL, { params });
};

// 전화번호 중복체크
export const getCheckPhoneAPI = (params) => {
  const url = '';
  return client.get(url, { params });
};

// 문자 전송
export const postSendMessageAPI = (data) => {
  return client.post(POST_COMMON_SENDMESSAGE, data);
};

// 교재주문 수정/교환 승인 문자 전송
export const postSendOrderMessageAPI = (data) => {
  return client.post(POST_ORDER_SENDMESSAGE, data);
};

// 지사 목록
export const getBranchListAPI = () => {
  return client.get(GET_COMMON_BRANCHLIST);
};

// 교육원 목록
export const getSchoolListAPI = (idx) => {
  return client.get(GET_COMMON_SCHOOLLIST.replace(':branch_idx', idx));
};

// 팀 목록
export const getTeamListAPI = () => {
  return client.get(GET_COMMON_TEAMLIST);
};

// 주소
export const getSidoListAPI = () => {
  return client.get(GET_COMMON_AREALIST);
};

//다운로드
export const excelDownloadAPI = (data) => {
  return client.get(GET_EXCEL_DOWNLOAD, {
    params: data,
    paramsSerializer: (params) => {
      return Object.entries(params)
        .map(([key, value]) => {
          if (Array.isArray(value)) {
            return value.map((v) => `${key}=${v}`).join('&');
          }
          return `${key}=${value}`;
        })
        .join('&');
    }
  });
};

// 다운로드 테스트
export const postExcelDownLoadAPI = (data) => {
  return client.post(GET_EXCEL_DOWNLOAD, data);
};

//교육원 상태별 현황
export const getSchoolStatisticsAllAPI = (tabType, params) => {
  return client.get(GET_SCHOOL_STATISTICS_ALL.replace(':tab_type', tabType), { params });
};

//교육원 상태별 현황
export const getCommonInfoSchoolAPI = (idx, { params }) => {
  const url = GET_COMMON_INFO_SCHOOL.replace(':branch_idx', idx);
  return client.get(url, { params });
};

//회원 상태별 현황
export const getCommonInfoMemberAPI = (idx, { params }) => {
  const url = GET_COMMON_INFO_MEMBER.replace(':branch_idx', idx);
  return client.get(url, { params });
};

// 교육 과정별 회원 현황
export const getMemberCourseStatusCurrentAPI = (idx, params) => {
  return client.get(GET_COMMON_INFO_COURCE.replace(':branch_idx', idx), { params });
};

// 연령별 회원 현황
export const getMemberAgeStatusCurrentAPI = (idx, params) => {
  return client.get(GET_COMMON_INFO_AGE.replace(':branch_idx', idx), { params });
};

//파일업로드
export const postSaveFileAPI = (data) => {
  return client.post(POST_FILE_UPLOAD, data, { headers: { 'Content-Type': 'multipart/form-data' } });
};

//파일업로드
export const postUploadExcelAPI = (data) => {
  return client.post(POST_EXCEL_UPLOAD, data, { headers: { 'Content-Type': 'multipart/form-data' } });
};

//파일업로드-지역관리
export const postUploadExcelBranchRegionAPI = (data) => {
  return client.post(POST_EXCEL_UPLOAD_BRANCH_REGION, data, { headers: { 'Content-Type': 'multipart/form-data' } });
};
//파일업로드-장바구니
export const postUploadExcelPointCartAPI = (data) => {
  return client.post(POST_EXCEL_UPLOAD_POINT_CART, data, { headers: { 'Content-Type': 'multipart/form-data' } });
};

//파일다운로드
export const getSaveFileAPI = (fileUrl) => {
  const config = {
    baseURL: process.env.REACT_APP_API_BASEURL,
    responseType: 'blob',
    method: 'GET',
    params: fileUrl,
    timeout: 20000
  };

  return axios.get(GET_COMMON_FILE_DOWNLOAD, config);
};

export const getSchoolCancelListAPI = (idx) => {
  return client.get(GET_COMMON_SCHOOL_CANCEL_LIST.replace(':branch_idx', idx));
};

//교재 카테고리
export const getBookCategoryAPI = (params) => {
  return client.get(GET_COMMON_BOOK_CATEGORY, { params });
};

//교재 카테고리 - 첫번째교재리스트
export const getBookFirstCategoryAPI = (params) => {
  return client.get(GET_COMMON_BOOK_FIRST, { params });
};

//물품 카테고리
export const getProductCategoryAPI = (params) => {
  return client.get(GET_COMMON_PRODUCT_CATEGORY, params);
};

//교재카테고리 추가(1차)
export const postBook1StCategoryAPI = (params) => {
  return client.post(POST_COMMON_BOOK_1ST_CATEGORY, params);
};
//교재카테고리 변경(1차)
export const putBook1StCategoryAPI = (params) => {
  return client.put(PUT_COMMON_BOOK_1ST_CATEGORY, params);
};

//교재카테고리 추가(2차)
export const postBook2StCategoryAPI = (params) => {
  return client.post(POST_COMMON_BOOK_2ST_CATEGORY, params);
};

//교재카테고리 수정(2차)
export const putBook2ndCategoryAPI = (params) => {
  return client.put(PUT_COMMON_BOOK_2ND_CATEGORY, params);
};


//교재카테고리 삭제(1차)
export const deleteBook1StCategoryAPI = (idx) => {
  return client.delete(DELETE_COMMON_BOOK_1ST_CATEGORY.replace(':idx', idx));
};

//교재카테고리 삭제(2차)
export const deleteBook2StCategoryAPI = (idx) => {
  return client.delete(DELETE_COMMON_BOOK_2ST_CATEGORY.replace(':idx', idx));
};

// 전체 메뉴리스트중에 한개만 수정할때 사용하는 부분
export const postColUpdateAPI = (params) => {
  return client.post(POST_COMMON_COL_UPDATE, params);
};

//교재 분류
export const getBookClassAPI = (params) => {
  return client.get(GET_COMMON_BOOK_CLASS, { params });
};

// 지사명 중복체크
export const getCheckBranchNameAPI = (params) => {
  return client.get(GET_COMMON_CHECK_BRANCH_NAME, { params });
};

// 교육원명 중복체크
export const getCheckSchoolNameAPI = (params) => {
  return client.get(GET_COMMON_CHECK_SCHOOL_NAME, { params });
};